import { fromJS, List, Record } from '@gonfalon/immutable-shim/immutableShim';
import { isEmpty } from 'lodash';
import qs from 'qs';

import type { CodeRefsFilter } from '#utils/codeRefs/types';

export class CodeReferenceFilters extends Record<CodeRefsFilter>({
  q: '',
  repo: '',
  branch: '',
  extensions: List(),
  showEmpty: false,
}) {
  isEmpty() {
    return (
      isEmpty(this.q) && isEmpty(this.repo) && isEmpty(this.branch) && this.extensions.isEmpty() && !this.showEmpty
    );
  }

  toQuery() {
    const ret = {} as Omit<CodeRefsFilter, 'extensions'> & { extensions?: string[] };

    if (!isEmpty(this.repo)) {
      ret.repo = this.repo;
    }

    if (!isEmpty(this.branch)) {
      ret.branch = this.branch;
    }

    if (!this.extensions.isEmpty()) {
      ret.extensions = this.extensions.sort().toJS();
    }

    if (this.showEmpty) {
      ret.showEmpty = true;
    }

    return ret;
  }

  toQueryString() {
    return qs.stringify(this.toQuery(), { indices: false });
  }
}

export function createCodeReferenceFilters(props = {}) {
  return props instanceof CodeReferenceFilters ? props : new CodeReferenceFilters(fromJS(props));
}
